export default __webpack_public_path__ + "static/Card31-f7b4395d1993c2f17a229046e827c56f.png";